import { inarixColors } from "inarix-theme";

export const AutocompleteStyles = {
  Autocomplete: {
    border: 1,
    borderColor: inarixColors.secondary_text_inarix,
    borderRadius: "5px",
    width: 350,

    "&:hover": {
      border: `1.3px solid ${inarixColors.light_inarix}`,
      color: "gray",
    },
  },
  AutoCompleteTextField: {
    "& .MuiInput-underline:after": {
      borderColor: "transparent",
    },

    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "transparent",
      },
      "&:hover fieldset": {
        borderColor: "transparent",
      },
      "&.Mui-focused fieldset": {
        borderColor: "transparent",
      },
    },
  },
  BoxOptions: {
    position: "sticky",
    top: "-1rem",
    background: "#fff",
    height: "60px",
    zIndex: "2",
    borderBottom: "1px solid",
  },
  BoxRenderTags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.5,
  },

  sideMenuStyle: {
    position: "fixed" as const,
    width: 350,
    bgcolor: "background.paper",
    border: "1px solid #e0e0e0",
    boxShadow: 6,
    p: 2,
    borderRadius: 2,
    maxHeight: "400px",
    overflow: "auto",
    zIndex: 9999,
    display: "flex",
    flexDirection: "column",
  },
};
